module.exports = __webpack_public_path__ + "static/fabric-style-1-aca7ff172782a466ad2bf99f9135bf26.png";